import { render, staticRenderFns } from "./signature_badge.vue?vue&type=template&id=8f0d9bb0&vue3"
import script from "./signature_badge.vue?vue&type=script&lang=js&vue3"
export * from "./signature_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports